import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ValueListPageFilterSchema } from './-zod-schema';

// 価値（Product Central > 価値）一覧。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx 側で
// 遅延ロードして bundle 分割する。
export const Route = createFileRoute('/_stacktrace/values/_layout/')({
  validateSearch: zodValidator(ValueListPageFilterSchema)
});